import {ScoringBreakdown} from "@core/model/retailer/application-form.model";
import {displayShortDate} from "@ui-kit/framework/util/static/date-format-utils";
import {displayListAsString, displayStatus, displayString} from "@ui-kit/framework/util/static/string-format-util";
import {
  Date,
  DisplayFunction,
  DisplayOrder,
  ExportFunction,
  Number,
  Percentage, SortDefault,
  String,
  TableDisplayedDefault
} from "@ui-kit/webkit/components/crud-item/crud-item-decorator";
import {Industry} from "../../settings/industries/industry.model";

export class RetailerPipelineRequest {
  [key: string]: any;
  industries: string[] = [];
  categories: string[] = [];
  offeringType: string | null = null;
  landlordUuid: string | null = null;
  offeringUuid: string | null = null;
  fromDate: string | null = null;
  toDate: string | null = null;

  constructor(offeringType: string | null, landlordUuid: string | null, offeringUuid: string | null, fromDate: string | null, toDate: string | null, industries: string[], categories: string[]) {
    this.offeringType = offeringType;
    this.landlordUuid = landlordUuid;
    this.offeringUuid = offeringUuid;
    this.fromDate = fromDate;
    this.toDate = toDate;
    this.industries = industries;
    this.categories = categories;
  }
}

export interface RetailerPipeline {
  id: number,
  companyName: string,
  retailerRegistrationDate: string,
  offeringUuid: string,
  landlordUuid: string,
  industryTypes: string,
  offeringType: string,
  industryCategoryTypes: string,
  overallScore: number,
  scoringBreakdown: ScoringBreakdown,
  usesActiveForm: boolean,
  outcome: string,
}

export class CrudRetailerPipeline {
  @DisplayOrder(1)
  @Number("ID")
  id?: number;

  @DisplayOrder(2)
  @DisplayFunction(displayShortDate)
  @ExportFunction(displayShortDate)
  @TableDisplayedDefault
  @Date("Application Date", "YYYY-MM-DD")
  @SortDefault("desc")
  retailerRegistrationDate?: string | Date | undefined;

  @DisplayOrder(3)
  @TableDisplayedDefault
  @String("Company Name")
  companyName: string;

  @DisplayOrder(4)
  @DisplayFunction(displayString)
  @TableDisplayedDefault
  @String("Industry Type")
  industryType?: string;

  @Percentage("Overall Score")
  @DisplayOrder(9)
  @TableDisplayedDefault
  overallScore!: number | null;

  @DisplayOrder(5)
  @TableDisplayedDefault
  @String("Application form version")
  formVersion?: string;

  @Percentage("Preferred And Passed")
  @DisplayOrder(6)
  @TableDisplayedDefault
  preferredAndPassed: number

  @Percentage("1st Rating results")
  @DisplayOrder(7)
  @TableDisplayedDefault
  firstRating: number

  @Percentage("2nd and 3rd Rating results")
  @DisplayOrder(8)
  @TableDisplayedDefault
  secondThirdRating: number

  industryTypes!: { industryType: Industry }[];
  usesActiveForm: boolean;
  scoringBreakdown: ScoringBreakdown;

  constructor(obj: any = {}) {
    obj = obj || {};
    this.id = obj.id;
    this.companyName = obj.companyName;
    this.retailerRegistrationDate = obj.retailerRegistrationDate;
    this.overallScore = obj.overallScore;
    this.usesActiveForm = obj.usesActiveForm;
    this.formVersion = obj.usesActiveForm ? 'Current' : 'Previous';
    this.industryTypes = obj.industryTypes;
    this.scoringBreakdown = obj.scoringBreakdown;
    this.preferredAndPassed = obj.scoringBreakdown ? obj.scoringBreakdown.preferredAndPassed : 0;
    this.firstRating = obj.scoringBreakdown ? obj.scoringBreakdown.firstRating : 0;
    this.secondThirdRating = obj.scoringBreakdown ? obj.scoringBreakdown.secondThirdRating : 0;
    this.industryType = obj.industryTypes ? displayListAsString(obj.industryTypes.split(',').map((m: string) => displayStatus(m))) : '';
  }
}
